import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import * as yup from 'yup';

const useAddressFormValidationSchema = () => {
	const { t } = useTranslation();
	return useMemo(
		() =>
			yup.object({
				country: yup
					.object()
					.shape({ label: yup.string(), value: yup.number() })
					.nullable()
					.required(t('Required')),
			}),
		[t],
	);
};

export default useAddressFormValidationSchema;
